// extracted by mini-css-extract-plugin
module.exports = {"cover":"HeaderBlock_cover__1oCsS","wrap":"HeaderBlock_wrap__1hW5W","header":"HeaderBlock_header__1-tc0","desc":"HeaderBlock_desc__3gsKm"};